import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { StatusApprovalsPipe } from '@fuse/pipes/approvals-status/status-translate.pipe';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { groupBy, union } from 'lodash';
import { ApprovalsEquipmentsService } from '../../services/approvals-equipments.service';
import english from './../../i18n/en.json';
import spanish from './../../i18n/es.json';
import portuguese from './../../i18n/pt.json';
import { DialogApprovalsEquipmentsApproveComponent } from './../dialog-approvals-approve/dialog-approvals-approve.component';
import { DialogApprovalsEquipmentsRejectComponent } from './../dialog-approvals-reject/dialog-approvals-reject.component';
var DialogApprovalsEquipmentsDiffComponent = /** @class */ (function () {
    function DialogApprovalsEquipmentsDiffComponent(dataToDiff, matDialogRef, fuseTranslationLoaderService, approvalsEquipmentsService, authenticationService, statusApprovalsPipe, translateService, matDialog) {
        var e_1, _a, e_2, _b;
        this.dataToDiff = dataToDiff;
        this.matDialogRef = matDialogRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.approvalsEquipmentsService = approvalsEquipmentsService;
        this.authenticationService = authenticationService;
        this.statusApprovalsPipe = statusApprovalsPipe;
        this.translateService = translateService;
        this.matDialog = matDialog;
        this.customFields = [];
        this.attachments = [];
        this.isExistingNumber = false;
        this.isViewMode = !this.authenticationService.hasPermission('approvals-equipments-edit');
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.dataToDiff.approval.equipment.archived = this.dataToDiff.approval.equipment.archived
            ? this.translateService.instant('APPROVALS_EQUIPMENTS.INACTIVE')
            : this.translateService.instant('APPROVALS_EQUIPMENTS.ACTIVE');
        this.dataToDiff.equipment.archived = this.dataToDiff.equipment.archived
            ? this.translateService.instant('APPROVALS_EQUIPMENTS.INACTIVE')
            : this.translateService.instant('APPROVALS_EQUIPMENTS.ACTIVE');
        this.dataToDiff.approval.approvalStatus = this.statusApprovalsPipe.transform(this.dataToDiff.approval.status);
        if (this.dataToDiff.equipment.customFields && this.dataToDiff.equipment.customFields.length) {
            this.dataToDiff.equipment.customFields.forEach(function (customField) { customField.status = 'old'; });
            this.dataToDiff.approval.equipment.customFields.forEach(function (customField) { customField.status = 'new'; });
            var customFieldsGrouped = Object.values(groupBy(union(this.dataToDiff.equipment.customFields, this.dataToDiff.approval.equipment.customFields), 'name'));
            try {
                for (var customFieldsGrouped_1 = tslib_1.__values(customFieldsGrouped), customFieldsGrouped_1_1 = customFieldsGrouped_1.next(); !customFieldsGrouped_1_1.done; customFieldsGrouped_1_1 = customFieldsGrouped_1.next()) {
                    var customFields = customFieldsGrouped_1_1.value;
                    if (customFields.length === 1) {
                        if (customFields[0].status === 'old') {
                            customFields.push({ status: 'new' });
                        }
                        else {
                            customFields.unshift({ status: 'old' });
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (customFieldsGrouped_1_1 && !customFieldsGrouped_1_1.done && (_a = customFieldsGrouped_1.return)) _a.call(customFieldsGrouped_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.customFields = customFieldsGrouped;
        }
        if ((this.dataToDiff.equipment.attachments && this.dataToDiff.equipment.attachments.length) ||
            (this.dataToDiff.approval.equipment.attachments && this.dataToDiff.approval.equipment.attachments.length)) {
            this.dataToDiff.equipment.attachments.forEach(function (attachment) { attachment.status = 'old'; });
            this.dataToDiff.approval.equipment.attachments.forEach(function (attachment) { attachment.status = 'new'; });
            var attachmentsGrouped = Object.values(groupBy(union(this.dataToDiff.equipment.attachments, this.dataToDiff.approval.equipment.attachments), 'path'));
            try {
                for (var attachmentsGrouped_1 = tslib_1.__values(attachmentsGrouped), attachmentsGrouped_1_1 = attachmentsGrouped_1.next(); !attachmentsGrouped_1_1.done; attachmentsGrouped_1_1 = attachmentsGrouped_1.next()) {
                    var attachments = attachmentsGrouped_1_1.value;
                    if (attachments.length === 1) {
                        if (attachments[0].status === 'old') {
                            attachments.push({ status: 'new' });
                        }
                        else {
                            attachments.unshift({ status: 'old' });
                        }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (attachmentsGrouped_1_1 && !attachmentsGrouped_1_1.done && (_b = attachmentsGrouped_1.return)) _b.call(attachmentsGrouped_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            this.attachments = attachmentsGrouped;
        }
    }
    DialogApprovalsEquipmentsDiffComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var approvalEquipment, existingEquipment;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        approvalEquipment = this.dataToDiff.approval.equipment;
                        return [4 /*yield*/, this.approvalsEquipmentsService.searchEquipment(approvalEquipment.number)];
                    case 1:
                        existingEquipment = _a.sent();
                        if (existingEquipment && existingEquipment.qrCode !== approvalEquipment.qrCode) {
                            this.isExistingNumber = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogApprovalsEquipmentsDiffComponent.prototype.openApproveDialog = function () {
        var _this = this;
        var equipmentsApprove = this.matDialog.open(DialogApprovalsEquipmentsApproveComponent, { panelClass: ['dialog-approvals-approve'], data: this.dataToDiff.approval });
        equipmentsApprove.afterClosed().subscribe(function (reload) {
            if (reload) {
                _this.matDialogRef.close(true);
            }
        });
    };
    DialogApprovalsEquipmentsDiffComponent.prototype.openRejectDialog = function () {
        var _this = this;
        var equipmentsReject = this.matDialog.open(DialogApprovalsEquipmentsRejectComponent, { panelClass: ['dialog-approvals-reject'], data: this.dataToDiff.approval });
        equipmentsReject.afterClosed().subscribe(function (reload) {
            if (reload) {
                _this.matDialogRef.close(true);
            }
        });
    };
    return DialogApprovalsEquipmentsDiffComponent;
}());
export { DialogApprovalsEquipmentsDiffComponent };
